<div class="auth-container">
  <div class="auth-filter"></div>
  <div class="auth-main-content-container">
    <div class="auth-intro">
      <intro-and-logo></intro-and-logo>
    </div>

    <div class="auth-login-and-image">
      <div class="auth-background-container">
        <svg
          width="318"
          height="389"
          viewBox="0 0 318 389"
          fill="none"
          class="auth-svg-image"
        >
          <defs>
            <clipPath id="clipPolygon">
              <path
                d="M0 121.234V388.98H265.733L317.747 336.875V0H121.022L0 121.234Z"
              />
            </clipPath>
          </defs>
          <image
            x="0"
            y="0"
            width="318"
            height="389"
            xlink:href="assets/Laptop.jpeg"
            clip-path="url(#clipPolygon)"
          />
        </svg>
      </div>

      <div class="auth-routed-content">
        <router-outlet></router-outlet>
      </div>

      <div class="auth-or-button">OR</div>

      <div class="auth-google-sign-in-container">
        <button class="auth-google-sign-in" (click)="loginWithGoogle()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 23 23"
            fill="none"
          >
            <path
              d="M20.4427 9.414H19.6875V9.37509H11.25V13.1251H16.5483C15.7753 15.3081 13.6983 16.8751 11.25 16.8751C8.14359 16.8751 5.625 14.3565 5.625 11.2501C5.625 8.14369 8.14359 5.62509 11.25 5.62509C12.6839 5.62509 13.9884 6.16603 14.9817 7.04962L17.6334 4.3979C15.9591 2.83744 13.7194 1.87509 11.25 1.87509C6.07266 1.87509 1.875 6.07275 1.875 11.2501C1.875 16.4274 6.07266 20.6251 11.25 20.6251C16.4273 20.6251 20.625 16.4274 20.625 11.2501C20.625 10.6215 20.5603 10.0079 20.4427 9.414Z"
              fill="#FFC107"
            />
            <path
              d="M2.95605 6.8865L6.03621 9.1454C6.86965 7.08197 8.88809 5.62509 11.2501 5.62509C12.684 5.62509 13.9886 6.16603 14.9818 7.04962L17.6336 4.3979C15.9592 2.83744 13.7195 1.87509 11.2501 1.87509C7.64918 1.87509 4.52637 3.90806 2.95605 6.8865Z"
              fill="#FF3D00"
            />
            <path
              d="M11.2499 20.6251C13.6715 20.6251 15.8718 19.6984 17.5354 18.1914L14.6338 15.736C13.6609 16.4759 12.4721 16.8761 11.2499 16.8751C8.81146 16.8751 6.741 15.3203 5.961 13.1504L2.90381 15.5059C4.45537 18.542 7.60631 20.6251 11.2499 20.6251Z"
              fill="#4CAF50"
            />
            <path
              d="M20.4427 9.414H19.6875V9.37509H11.25V13.1251H16.5483C16.1785 14.164 15.5125 15.0719 14.6325 15.7365L14.6339 15.7356L17.5355 18.1909C17.3302 18.3774 20.625 15.9376 20.625 11.2501C20.625 10.6215 20.5603 10.0079 20.4427 9.414Z"
              fill="#1976D2"
            />
          </svg>
          <p class="auth-google-text">Sign in with Google</p>
        </button>
      </div>
    </div>
  </div>
</div>
